var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// CSRFトークンを取得する関数
export const getCSRFToken = () => {
    const metaTag = document.querySelector('meta[name="csrf-token"]');
    return metaTag ? metaTag.content : null;
};
// 一覧APIのレスポンス検証。想定外の形を空配列へ寄せると「レスポンス形式が変わった」異常が
// 「該当データ0件」と区別できなくなるため、例外にして呼び出し側の catch へ渡す
export const assertArrayResponse = (response, url) => {
    if (!Array.isArray(response)) {
        throw new Error(`Unexpected API response (expected array): ${url}`);
    }
    return response;
};
export const fetcher = (url_1, ...args_1) => __awaiter(void 0, [url_1, ...args_1], void 0, function* (url, options = {}) {
    const csrfToken = getCSRFToken();
    const headers = Object.assign({ 'Content-Type': 'application/json' }, options.headers);
    if (csrfToken) {
        headers['X-CSRF-Token'] = csrfToken;
    }
    const response = yield fetch(url, Object.assign(Object.assign({}, options), { headers, credentials: 'same-origin' }));
    if (response.status === 401) {
        window.location.href = '/users/sign_in';
        const error = new Error('Unauthorized');
        error.status = 401;
        throw error;
    }
    if (!response.ok) {
        const errorData = yield response.json().catch(() => ({}));
        const error = new Error(errorData.error || errorData.message || (Array.isArray(errorData.errors) ? errorData.errors.join('、') : undefined) || `API request failed: ${response.status}`);
        error.status = response.status;
        throw error;
    }
    if (response.status === 204)
        return null;
    return response.json();
});
const API_BASE_URL = '/api/inside/v1';
export const api = {
    get: (url_1, ...args_1) => __awaiter(void 0, [url_1, ...args_1], void 0, function* (url, options = {}) {
        const csrfToken = getCSRFToken();
        const fullUrl = url.startsWith('/api') ? url : `${API_BASE_URL}${url}`;
        const headers = {
            'Content-Type': 'application/json',
        };
        if (csrfToken) {
            headers['X-CSRF-Token'] = csrfToken;
        }
        const response = yield fetch(fullUrl, {
            method: 'GET',
            headers,
            credentials: 'same-origin', // セッションクッキーを含める
        });
        if (response.status === 401) {
            window.location.href = '/users/sign_in';
            throw new Error('Unauthorized');
        }
        if (!response.ok) {
            const errorData = yield response.json().catch(() => ({}));
            throw new Error(errorData.message || `API request failed: ${response.status}`);
        }
        if (options.responseType === 'blob') {
            return { data: yield response.blob() };
        }
        return { data: yield response.json() };
    }),
    post: (url_1, data_1, ...args_1) => __awaiter(void 0, [url_1, data_1, ...args_1], void 0, function* (url, data, options = {}) {
        const csrfToken = getCSRFToken();
        const fullUrl = url.startsWith('/api') ? url : `${API_BASE_URL}${url}`;
        const headers = Object.assign({}, options.headers);
        // FormDataの場合はContent-Typeを設定しない（ブラウザが自動設定）
        if (!(data instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
        }
        if (csrfToken) {
            headers['X-CSRF-Token'] = csrfToken;
        }
        const response = yield fetch(fullUrl, Object.assign({ method: 'POST', headers, body: data instanceof FormData ? data : (data ? JSON.stringify(data) : undefined), credentials: 'same-origin' }, options));
        if (response.status === 401) {
            window.location.href = '/users/sign_in';
            throw new Error('Unauthorized');
        }
        if (!response.ok) {
            const errorData = yield response.json().catch(() => ({}));
            // エラーレスポンスのデータを含むErrorオブジェクトを作成
            const error = new Error(errorData.message || `API request failed: ${response.status}`);
            error.response = { data: errorData };
            throw error;
        }
        return { data: yield response.json() };
    }),
    put: (url_1, data_1, ...args_1) => __awaiter(void 0, [url_1, data_1, ...args_1], void 0, function* (url, data, options = {}) {
        const csrfToken = getCSRFToken();
        const fullUrl = url.startsWith('/api') ? url : `${API_BASE_URL}${url}`;
        const headers = Object.assign({ 'Content-Type': 'application/json' }, options.headers);
        if (csrfToken) {
            headers['X-CSRF-Token'] = csrfToken;
        }
        const response = yield fetch(fullUrl, Object.assign({ method: 'PUT', headers, body: data ? JSON.stringify(data) : undefined, credentials: 'same-origin' }, options));
        if (response.status === 401) {
            window.location.href = '/users/sign_in';
            throw new Error('Unauthorized');
        }
        if (!response.ok) {
            const errorData = yield response.json().catch(() => ({}));
            throw new Error(errorData.message || `API request failed: ${response.status}`);
        }
        return { data: yield response.json() };
    }),
    delete: (url_1, data_1, ...args_1) => __awaiter(void 0, [url_1, data_1, ...args_1], void 0, function* (url, data, options = {}) {
        const csrfToken = getCSRFToken();
        const fullUrl = url.startsWith('/api') ? url : `${API_BASE_URL}${url}`;
        const headers = Object.assign({ 'Content-Type': 'application/json' }, options.headers);
        if (csrfToken) {
            headers['X-CSRF-Token'] = csrfToken;
        }
        const response = yield fetch(fullUrl, Object.assign({ method: 'DELETE', headers, credentials: 'same-origin' }, options));
        if (response.status === 401) {
            window.location.href = '/users/sign_in';
            throw new Error('Unauthorized');
        }
        if (!response.ok) {
            const errorData = yield response.json().catch(() => ({}));
            throw new Error(errorData.message || `API request failed: ${response.status}`);
        }
        return { data: yield response.json() };
    }),
};
